import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {LovValueSavePayload} from '../../../impl/service/payload/lovValueSave.payload';
import {LovValue} from '../../model/LovValue.model';
import {BaseView} from '../../../../../../core/view/base.view';
import {LovListSummary} from '../../../../lov-list/api/model/LovListSummary.model';
import {LovListFindByNameService} from '../../../../lov-list/impl/service/lovListFindByName.service';
import {LovValueSaveService} from '../../../impl/service/lovValueSave.service';
import {LovValueFindOneService} from '../../../impl/service/lovValueFindOne.service';

@Component({
    selector: 'app-lov-value-update',
    templateUrl: './lov-value-update.component.html',
    viewProviders: [
        LovListFindByNameService,
        LovValueSaveService,
        LovValueFindOneService]
})
export class LovValueUpdateComponent extends BaseView implements OnInit {

    formGroup: UntypedFormGroup;

    @Input() returnUrl: string;
    @Input() id: number;
    @Input() titleLabel: string;
    @Input() lovListName: string;
    @Input() lovValue: LovValue;
    @Input() label: string;
    @Input() inDialog = false;

    showParentInput = true;
    showCommentInput = true;
    showParamInput = false;
    paramLabel = undefined;

    loading = false;


    @Output() entitySaved = new EventEmitter<LovValue>();
    @Output() lovListSummaryLoadedEvent = new EventEmitter<LovListSummary>();

    /*
    Possible values are:
      string
      positiveNumber
     */
    @Input() paramInputType = 'string';

    constructor(private formBuilder: UntypedFormBuilder,
                public service: LovValueSaveService,
                public lovListService: LovListFindByNameService,
                public findOneService: LovValueFindOneService) {
        super();

        this.formGroup = this.formBuilder.group({
            label: new UntypedFormControl('', Validators.required),
            parentValueId: new UntypedFormControl(),
            comment: new UntypedFormControl(),
            param: new UntypedFormControl('',
                this.paramInputType === 'positiveNumber' ? Validators.min(0) : Validators.maxLength(45)),
            lovListName: new UntypedFormControl(),
            summary: this.formBuilder.group({
                id: new UntypedFormControl('')
            })
        });
    }

    ngOnInit() {
        if (!this.id) {
            this.loading = true;
            this.lovListService.loadEntity(this.lovListName)
                .then((lovList) => {
                    if (!lovList) {
                        this.redirectTo('404');
                    }
                    this.onLovListSummaryChanged(lovList.summary);
                })
                .finally(() => this.loading = false);
        }

        this.formGroup.patchValue({
            lovListName: this.lovListName,
            label: this.label,
        });

    }

    entityLoaded(entity: LovValue) {
        this.formGroup.patchValue({
            label: entity.summary.label,
            parentValueId: entity.parent?.id,
            comment: entity.comment,
            param: entity.summary.param,
            lovListName: entity.lovList.name,
            summary: {
                id: entity.summary.id
            }
        });

        this.onLovListSummaryChanged(entity.lovList);
    }

    onLovListSummaryChanged(lovListSummary: LovListSummary) {
        if (this.lovListSummaryLoadedEvent) {
            this.lovListSummaryLoadedEvent.emit(lovListSummary);
        }

        this.showParentInput = lovListSummary.model.hasParent;
        this.showParamInput = !!lovListSummary.model.paramType;
        this.showCommentInput = lovListSummary.model.hasComment;
        this.paramLabel = lovListSummary.model.paramLabel;
    }

    onEntitySaved(entity: LovValue) {
        if (this.entitySaved) {
            this.entitySaved.emit(entity);
        }
    }

    buildPayload = (): LovValueSavePayload => {
        return this.formGroup.value;
    }

}
